import LogoDiss from "./logo-diss.png";
import LogoBlast from "./logo-blast.png";
import LogoPangea from "./logo-pangea.png";
import LogoBubble from "./logo-bubble.png";
import LogoBy from "./logo-bayram.png";

import CoverDiss from "./cover-diss.gif";
import CoverPangea from "./cover-pangea.jpg";
import CoverBlast from "./cover-blast.gif";
import CoverBubble from "./cover-bubble.gif";
import CoverBayram from "./cover-bayram.gif";

// Blast project images
import BlastDesktop from "./blast/blast-desktop.png";
import BlastMobile from "./blast/blast-mobile.png";
import BlastTablet from "./blast/blast-tablet.png";
import BlastProiettili from "./blast/proiettili.jpg";

// Bubble project images
import BubbleDesktop from "./bubble/bubble-desktop.png";
import BubbleMobile from "./bubble/bubble-mobile.png";
import BubbleTablet from "./bubble/bubble-tablet.png";

// Pangea project images
import PangeaDesktop from "./pangea/pangea-desktop.png";
import PangeaMobile from "./pangea/pangea-mobile.png";
import PangeaTablet from "./pangea/pangea-tablet.png";
import PangeaCollana1 from "./pangea/collana1.jpg";
import PangeaCollana2 from "./pangea/collana2.jpg";
import PangeaCollana3 from "./pangea/collana3.jpg";
import PangeaTeatro0 from "./pangea/teatro-0.jpg";
import PangeaTeatro1 from "./pangea/teatro-1.jpg";
import PangeaTeatro2 from "./pangea/teatro-2.jpg";
import PangeaTeatro3 from "./pangea/teatro-3.jpg";

// Diss project images
import DissDesktop from "./diss/dissipatio-desktop.png";
import DissTablet from "./diss/dissipatio-tablet.png";
import DissMobile from "./diss/dissipatio-mobile.png";
import DissCollana from "./diss/collana.png";
import DissClub from "./diss/club.png";
import DissNucleoCollana from "./diss/nucleo-collana.jpg";
import DissNucleoDispaccio from "./diss/nucleo-dispaccio.png";
import DissNucleoMartedi from "./diss/nucleo-martedi.jpg";

// Bayram project images
import BayramDesktop from "./bayram/bayram-desktop.png";
import BayramMobile from "./bayram/bayram-mobile.png";
import BayramTablet from "./bayram/bayram-tablet.png";
import BayramFlyer from "./bayram/bayram-flyer.png";
import Bayram1 from "./bayram/bayram-1.jpg";
import Bayram2 from "./bayram/bayram-2.jpg";
import Bayram3 from "./bayram/bayram-3.jpg";
import Bayram4 from "./bayram/bayram-4.jpg";
import Bayram5 from "./bayram/bayram-5.jpg";
import Bayram6 from "./bayram/bayram-6.jpg";
import Bayram7 from "./bayram/bayram-7.jpg";
import Bayram8 from "./bayram/bayram-8.jpg";
import Bayram9 from "./bayram/bayram-9.jpg";
import Bayram10 from "./bayram/bayram-10.jpg";
import Bayram11 from "./bayram/bayram-11.jpg";
import Bayram12 from "./bayram/bayram-12.jpg";
import Bayram13 from "./bayram/bayram-13.jpg";
import Bayram14 from "./bayram/bayram-14.jpg";
import Bayram15 from "./bayram/bayram-15.jpg";
import Bayram16 from "./bayram/bayram-16.jpg";

// Talk images (press logos)
import TalkAg from "./talk/ag.png";
import TalkAvvenire from "./talk/avvenire.png";
import TalkDagospia from "./talk/dagospia.png";
import TalkIlFoglio from "./talk/il-foglio.png";
import TalkIlGiornale from "./talk/il-giornale.png";
import TalkLaRepubblica from "./talk/la-republica.png";
import TalkPrimaComunicazione from "./talk/prima-comunicazione.png";
import TalkAdnkronos from "./talk/adnkronos.png";
import TalkAnsa from "./talk/ansa.png";
import TalkCorriereDellaSera from "./talk/corriere-della-sera.png";
import TalkIlMessaggero from "./talk/il-messaggero.png";
import TalkOpen from "./talk/open.png";
import TalkOsservatoreRomano from "./talk/osservatore-romano.png";
import TalkRai from "./talk/rai.png";
import TalkTheRomaPost from "./talk/the-roma-post.png";

export const Images = {
  logoDiss: LogoDiss,
  logoBlast: LogoBlast,
  logoPangea: LogoPangea,
  logoBubble: LogoBubble,
  logoBy: LogoBy,
  coverDiss: CoverDiss,
  coverPangea: CoverPangea,
  coverBlast: CoverBlast,
  coverBubble: CoverBubble,
  coverBayram: CoverBayram,
  blastDesktop: BlastDesktop,
  blastMobile: BlastMobile,
  blastTablet: BlastTablet,
  blastProiettili: BlastProiettili,
  bubbleDesktop: BubbleDesktop,
  bubbleMobile: BubbleMobile,
  bubbleTablet: BubbleTablet,
  pangeaDesktop: PangeaDesktop,
  pangeaMobile: PangeaMobile,
  pangeaTablet: PangeaTablet,
  pangeaCollana1: PangeaCollana1,
  pangeaCollana2: PangeaCollana2,
  pangeaCollana3: PangeaCollana3,
  pangeaTeatro0: PangeaTeatro0,
  pangeaTeatro1: PangeaTeatro1,
  pangeaTeatro2: PangeaTeatro2,
  pangeaTeatro3: PangeaTeatro3,
  dissDesktop: DissDesktop,
  dissTablet: DissTablet,
  dissMobile: DissMobile,
  dissCollana: DissCollana,
  dissClub: DissClub,
  dissNucleoCollana: DissNucleoCollana,
  dissNucleoDispaccio: DissNucleoDispaccio,
  dissNucleoMartedi: DissNucleoMartedi,
  bayramDesktop: BayramDesktop,
  bayramMobile: BayramMobile,
  bayramTablet: BayramTablet,
  bayramFlyer: BayramFlyer,
  bayram1: Bayram1,
  bayram2: Bayram2,
  bayram3: Bayram3,
  bayram4: Bayram4,
  bayram5: Bayram5,
  bayram6: Bayram6,
  bayram7: Bayram7,
  bayram8: Bayram8,
  bayram9: Bayram9,
  bayram10: Bayram10,
  bayram11: Bayram11,
  bayram12: Bayram12,
  bayram13: Bayram13,
  bayram14: Bayram14,
  bayram15: Bayram15,
  bayram16: Bayram16,
  talkAg: TalkAg,
  talkAvvenire: TalkAvvenire,
  talkDagospia: TalkDagospia,
  talkIlFoglio: TalkIlFoglio,
  talkIlGiornale: TalkIlGiornale,
  talkLaRepubblica: TalkLaRepubblica,
  talkPrimaComunicazione: TalkPrimaComunicazione,
  talkAdnkronos: TalkAdnkronos,
  talkAnsa: TalkAnsa,
  talkCorriereDellaSera: TalkCorriereDellaSera,
  talkIlMessaggero: TalkIlMessaggero,
  talkOpen: TalkOpen,
  talkOsservatoreRomano: TalkOsservatoreRomano,
  talkRai: TalkRai,
  talkTheRomaPost: TalkTheRomaPost,
};
